<div style="display: block">
  <div echarts [options]="options" class="demo-chart"></div>
</div>